import { NavLink } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../auth";
import { Icon, type IconName } from "./Icon";

type NavItem = { to: string; label: string; icon: IconName; end?: boolean };

const CATALOG: NavItem[] = [
  { to: "/", label: "Overview", icon: "house", end: true },
  { to: "/institutions", label: "Institutions", icon: "building" },
  { to: "/products", label: "Cards", icon: "sparkles" },
  { to: "/merchant-icons", label: "Merchants", icon: "bag" },
  { to: "/investment-assets", label: "Investment assets", icon: "chart" },
];

const REFERENCE: NavItem[] = [
  { to: "/networks", label: "Networks", icon: "network" },
  { to: "/card-types", label: "Card types", icon: "creditcard" },
  { to: "/account-types", label: "Account types", icon: "wallet" },
];

function navClass({ isActive }: { isActive: boolean }) {
  return isActive ? "nav-link active" : "nav-link";
}

function NavItems({ items }: { items: NavItem[] }) {
  return (
    <>
      {items.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end} className={navClass}>
          <Icon name={item.icon} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </>
  );
}

export function AppShell({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth();

  const identity = user?.email ?? user?.sub ?? "Signed in";
  const initial = (user?.email ?? "A").trim().charAt(0).toUpperCase();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <div className="logo">₱</div>
          <div>
            <strong>Pambayad</strong>
            <span>Catalog CMS</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">Catalog</div>
          <NavItems items={CATALOG} />
          <div className="nav-section">Reference</div>
          <NavItems items={REFERENCE} />
        </nav>

        <div className="sidebar-foot">
          <div className="account">
            <div className="avatar">{initial}</div>
            <div className="account-meta">
              <strong title={identity}>{identity}</strong>
              <span>Administrator</span>
            </div>
          </div>
          <button
            className="btn btn-quiet btn-block btn-sm"
            type="button"
            onClick={() => void signOut()}
          >
            <Icon name="signout" size={15} />
            Sign out
          </button>
        </div>
      </aside>

      <div className="content">{children}</div>
    </div>
  );
}
